<template>
  <YContainer>
    <z-breadcrumb
      :items="[
        { text: 'Página inicial', url: 'https://querobolsa.com.br/' },
        { text: 'Programas do Governo', url: 'https://querobolsa.com.br/programas-do-governo' },
        { text: pageName },
      ]"
    />

    <FinancialAidArticle :page="page" />
    <CampaignBanner
      :campaign-data="campaignData"
      :is-loading="campaignLoading"
    />
  </YContainer>
</template>

<script>
import { YContainer } from '@quero/yeti'

import { retry } from '~/assets/js/utils/http'
import capitalizeSlug from '~/assets/js/utils/capitalize-slug'
import CampaignBanner from '~/components/campaign-banner'
import FinancialAidArticle from '~/components/financial-aid-article'
import hotjarMixin from '~/mixins/hotjar'
import { CAMPAIGN_CONFIG_URL } from '~/utils/constants/campaignConfig'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Home',

  components: {
    FinancialAidArticle,
    YContainer,
    CampaignBanner,
  },

  mixins: [
    hotjarMixin,
  ],

  async asyncData ({ params, $cms, error }) {
    const home = params.home

    if (!home) return error({ statusCode: 500, message: 'Failed to fetch content, page not defined.\n' })

    const pageName = capitalizeSlug(home)

    const URL = `/items/FinancialAidPages?filter[path][_eq]=/${home}`

    const request = await retry(
      () => $cms.$get(URL),
      { retries: 6 },
    ).catch((err) => {
      error({ statusCode: 500, message: 'Failed to fetch content.\n' + err.message })
    })

    if (!request?.data.length) return error({ statusCode: 500, message: `Failed to fetch content for page ${params.home}.\n` })

    const campaignRequest = await retry(
      () => $cms.$get(CAMPAIGN_CONFIG_URL),
      { retries: 2 },
    ).catch((err) => {
      error({ statusCode: 500, message: 'Failed to fetch campaign.\n' + err.message })
    })
    return {
      pageName,
      page: Object.freeze(request?.data[0]),
      campaignData: campaignRequest?.data,
    }
  },
  data () {
    return {
      pageName: '',
      page: {
        title: '',
        content: [],
        sidebar: [
          {
            links: [],
          },
        ],
      },
      campaignData: [],
      campaignLoading: true,
    }
  },
  head () {
    return {
      title: this.page.headTitle,
      meta: this.page.headMeta || [],
      link: this.page.headLink,
    }
  },
  mounted () {
    this.campaignLoading = false
  },
}
</script>
